// extracted by mini-css-extract-plugin
export default {"divider":"styles-module__divider__src-labstep-web-screens-Master-Index-LeftPane-_AReuK","collapsed":"styles-module__collapsed__src-labstep-web-screens-Master-Index-LeftPane-_LMi_h"};